import { createFileRoute } from '@tanstack/react-router';

import AuthPageSkeleton from '@/features/auth/components/AuthPageSkeleton/AuthPageSkeleton';

export const Route = createFileRoute('/_auth/register')({
  pendingComponent: AuthPageSkeleton,
});
